import RequestAbstract from "../abstract";

export default class PublicFraudComments extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = 'api/public-fraud-comments';
    }
}
